import { BaseModel } from "../Generics/BaseModel"
import { converteDateToSql } from "../Generics/Helps"

export class OrderCanceledEntity extends BaseModel {
  id: number

  employeeId: string

  reason: string

  concurrencyToken: string

  date: string

  orderId: number

  constructor(data: Partial<OrderCanceledEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.employeeId = data.employeeId ?? ""

    this.reason = data.reason ?? ""
    this.concurrencyToken = data.concurrencyToken ?? ""

    this.date = data.date ?? converteDateToSql(new Date())

    this.orderId = data.orderId ?? -1
  }

  protected override getJsonFields(): string[] {
    return ["reason", "concurrencyToken"]
  }
}
